import React, { useEffect } from "react";
import "./styles.scss";
import { IonImg, IonLabel } from "@ionic/react";
import { useTranslation } from "react-i18next";
import starIcon from "../../images/icons/star-sharp.svg"
import { ReduxSelectors } from "../../redux/shared/types";
import { useSelector} from "react-redux";

type Props = {
  className?: string;
  starsLabel: string;
}

const CurrentBalanceBox: React.FC<Props> = ({ className, starsLabel }) => {
  const { t } = useTranslation()
  const {starsBalance} = useSelector(({ billingRewards }: ReduxSelectors) => billingRewards)
  const currentTheme = useSelector(({ theme }: ReduxSelectors) => theme.currentTheme);


  useEffect(()=>{
    const balanceInfoContainer = document.querySelector('.current-balance-box .balance-info');
    if(currentTheme==='dark'){
      balanceInfoContainer?.setAttribute('style', 'border-color: #fffff;');
    }else{
      balanceInfoContainer?.setAttribute('style', 'border-color: #00000;');
    }
  },[currentTheme])

  return (
    <div className={`current-balance-box ${className}`}>
      <div className="balance-info">
        <div className="balance-left">
          <IonImg src={starIcon} />
          <IonLabel>{starsLabel}</IonLabel>
        </div>

        <div className="balance-right">
          <IonLabel>{t('billing.starsStatus.total')}</IonLabel>
          <IonLabel>{starsBalance?.toString()}</IonLabel>
          <IonLabel>{t('billing.starsStatus.stars')}</IonLabel>
        </div>
      </div>
    </div>
  );
};

export default CurrentBalanceBox;
